import { render, staticRenderFns } from "./VideoCrawlerConfiguration.vue?vue&type=template&id=4b1b77d7&scoped=true&"
import script from "./VideoCrawlerConfiguration.vue?vue&type=script&lang=js&"
export * from "./VideoCrawlerConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./VideoCrawlerConfiguration.vue?vue&type=style&index=0&id=4b1b77d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1b77d7",
  null
  
)

export default component.exports